import React, { useState, useEffect } from "react";
import ReactDragListView from "react-drag-listview";
import './DragableList.css' // not remove
import { useBestOf } from "../../context/BestOf";
import DragableItem from "./DargableItem";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  containerDragableList: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center"
  },
  itemPostOption: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "space-evenly"
  },
  puceListDragable: { listStyleType: "none", padding: "10px" }
}));

const DragableList = ({ bestOffDay, day }: any) => {
  const classes = useStyles();
  const [dataPost, setDataPost] = useState([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {state, dispatch} = useBestOf();

  useEffect(() => {
    setDataPost(bestOffDay);
  }, [bestOffDay]);
  
  const dragProps = {
    onDragEnd(fromIndex: any, toIndex: any) {
      const data = [...dataPost];
      const item = data.splice(fromIndex, 1)[0];
      data.splice(toIndex, 0, item);
      if (day) {
        dispatch({type: 'CHANGE_ORDER_POST_DAY', payload: { day, newArray: data }})
      } else {
        dispatch({type: 'CHANGE_ORDER_COVER', payload: { newArray: data }})
      }
    },
    nodeSelector: 'li',
    handleSelector: 'a'
  };

  return (
    <div className={classes.containerDragableList}>
      <ReactDragListView style={{witdh: "-webkit-fill-available"}} {...dragProps}>
        <div className={classes.puceListDragable}>
          {dataPost.map((item: any, index: any) => (
            <li key={index}>
              <DragableItem style={{witdh: '100%'}} item={item} day={day} />
            </li>
          ))}
        </div>
      </ReactDragListView>
    </div>
  );
};

export default DragableList;